import { render } from "./ProductArticlePage.vue?vue&type=template&id=69ba7e92&scoped=true"
import script from "./ProductArticlePage.vue?vue&type=script&lang=js"
export * from "./ProductArticlePage.vue?vue&type=script&lang=js"

import "./ProductArticlePage.vue?vue&type=style&index=0&id=69ba7e92&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ba7e92"]])

export default __exports__